export enum StrategySplitterLabel{
        CHEAP_ONE_COST_STRATEGY = "Economizer",
        SHARE_COST_STRATEGY = "Shared",
        PRIORITY_COST_PRIORITY = "Staged",
        ENVIRONMENT_COST_STRTEGY = "Temperature"
}